import { Button } from '@iwoca/orion';
import { REQUEST_CHANGE_ROUTER } from '@iwRouter/IwRouter.actions';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import styles from '../FundingSteps.module.css';
import messages from './AllRequirementsCompletedStep.messages';
import { buildLocationWithSearch } from '../../../drawDown/DrawDownHelper';
import { FormalOffer } from '../../../myOffers/MyOffers.types';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    redirectToConfirm: ({
        offerId,
        amount,
        sweep
    }: {
        offerId: FormalOffer['offer_id'];
        amount: number;
        sweep?: string;
    }) => {
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            //@ts-ignore
            location: buildLocationWithSearch({
                pathname: '/confirm-funding/',
                offerId,
                amount,
                sweep
            })
        });
    }
});

const AllRequirementsCompletedStep = ({
    offerId,
    amount,
    sweep,
    redirectToConfirm,
    isInterestOnlyExtension,
    isAccessUser
}: {
    offerId: FormalOffer['offer_id'];
    amount: number;
    sweep?: string;
    isInterestOnlyExtension?: boolean;
    isAccessUser: boolean;
} & ReturnType<typeof mapDispatchToProps>) => {
    return (
        <div className={styles.stepContainer}>
            <div className={styles.stepMessages}>
                <span className={styles.title}>
                    <FormattedMessage
                        {...(isAccessUser
                            ? messages.accessUserTitle
                            : messages.title)}
                    />
                </span>
                <span className={styles.caption}>
                    {isAccessUser ? (
                        <FormattedMessage {...messages.accessUserCaption} />
                    ) : (
                        <FormattedMessage
                            {...(isInterestOnlyExtension
                                ? messages.interestOnlyCaption
                                : messages.caption)}
                            values={{
                                br: <br />,
                                next: (
                                    <span className={styles.highlightedAction}>
                                        <FormattedMessage
                                            {...messages.action}
                                        />
                                    </span>
                                )
                            }}
                        />
                    )}
                </span>
            </div>
            {!isAccessUser && (
                <Button
                    variant="success"
                    className={styles.actionButton}
                    onClick={() => {
                        redirectToConfirm({ offerId, amount, sweep });
                    }}
                    data-action-name="Next to confirm funding"
                >
                    <FormattedMessage {...messages.action} />
                </Button>
            )}
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(AllRequirementsCompletedStep);
